import React, { useEffect, useState } from 'react';
import Button from '../../../components/Button';
import Input from '../../../components/Input';
import { IoSearchOutline } from 'react-icons/io5';
import { HiOutlineArrowLeft } from 'react-icons/hi';
import { Link } from 'react-router-dom';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import Super_admin_web_protal from '../../../layout/Super_admin_web_portal';
import { ClosureTableSkeleton } from '../../../components/Skeleton';
import { Base_url } from '../../../utils/Base_url';

const SuperRunningCases = () => {
  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  const [filteredDeposits, setFilteredDeposits] = useState([]);

  const currentPageData = filteredDeposits.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (newPage) => setCurrentPage(newPage);

  // Fetch data from the new API
  useEffect(() => {
    fetchRunningCases();
  }, []);

  const fetchRunningCases = async () => {
    setIsFetching(true);
    try {
      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };

      const response = await fetch(
        `${Base_url}/v1/worker/running-enrollement`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const result = await response.json();

      if (result.success && result.runningCases) {
        setData(result.runningCases);
        setFilteredDeposits(result.runningCases);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsFetching(false);
    }
  };

  // Filter function
  useEffect(() => {
    filterDeposits();
  }, [data, searchTerm]);

  const filterDeposits = () => {
    let filtered = data || [];

    if (searchTerm.trim()) {
      const lowercasedSearchTerm = searchTerm.toLowerCase();
      filtered = filtered.filter((item) => {
        const nameMatch = item?.investorName?.toLowerCase().includes(lowercasedSearchTerm);
        const cnicMatch = item?.investorCnic?.toLowerCase().includes(lowercasedSearchTerm);
        const planMatch = item?.planId?.planName?.toLowerCase().includes(lowercasedSearchTerm);
        const planIdMatch = item?.planId?._id?.toLowerCase().includes(lowercasedSearchTerm);

        return nameMatch || cnicMatch || planMatch || planIdMatch;
      });
    }

    setFilteredDeposits(filtered);
    setCurrentPage(1);
  };

  // Format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-PK', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  // Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-PK');
  };

  // Get plan name safely
  const getPlanName = (item) => {
    if (item?.planId?.planName) {
      return item.planId.planName;
    }
    // Fallback if planId is a string (old structure)
    return item?.planId || 'N/A';
  };

  // Get plan ID safely
  const getPlanId = (item) => {
    if (item?.planId?._id) {
      return item.planId._id.slice(-8); // Show last 8 characters
    }
    // Fallback if planId is a string (old structure)
    return item?.planId?.slice(-8) || 'N/A';
  };

  return (
    <>
      <Super_admin_web_protal
        language={<p className="sm:block hidden">English | Urdu</p>}
        ToggleBtn={
          <div className="flex gap-4 items-center">
            <HiOutlineArrowLeft />
            {/* <h2 className="">Soon Enrollment Investors</h2> */}
          </div>
        }
        title_props={
          <div className="w-96 relative">
            <Input
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder={'Search'}
              className={'border bg-white w-full rounded-full'}
            />
            <Button
              Icon={<IoSearchOutline className="text-white text-xl" />}
              label={'search'}
              className={'absolute top-0 right-0 bg-secondary text-white uppercase font-normal rounded-full'}
            />
          </div>
        }
      >
        <div className="w-full mb-4 sm:hidden block relative">
          <Input
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder={'Search by name, CNIC or Plan Name'}
            className={'border bg-white w-full rounded-full'}
          />
          <Button
            Icon={<IoSearchOutline className="text-white text-xl" />}
            label={'search'}
            className={'absolute top-0 right-0 bg-secondary text-white uppercase font-normal rounded-full'}
          />
        </div>

        <div className="sm:flex block justify-between items-center mb-6">
          <div>
            {/* <h2 className="sm:block hidden">Running Cases</h2> */}
          </div>
        </div>

        <section className="mb-20 text-gray-800">
          <div className="block rounded-lg bg-white shadow">
            <div className="overflow-hidden">
              <div className="w-full">
                <div className="min-w-full">
                  <div className="overflow-x-auto">
                    <table className="min-w-full mb-0">
                      <thead className="bg-gray-50">
                        <tr>
                          <th scope="col" className="text-sm text-darkGray font-medium px-6 py-4 text-left">
                            Investor Name
                          </th>
                          <th scope="col" className="text-sm text-darkGray font-medium px-6 py-4 text-center">
                            CNIC No
                          </th>
                          <th scope="col" className="text-sm text-darkGray font-medium px-6 py-4 text-center">
                            Plan Name
                          </th>
                          <th scope="col" className="text-sm text-darkGray font-medium px-6 py-4 text-center">
                            Years
                          </th>
                          <th scope="col" className="text-sm text-darkGray font-medium px-6 py-4 text-center">
                            Total Deposit
                          </th>
                          <th scope="col" className="text-sm text-darkGray font-medium px-6 py-4 text-center">
                            Deposit Date
                          </th>
                          <th scope="col" className="text-sm text-darkGray font-medium px-6 py-4 text-center whitespace-nowrap min-w-[120px]">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {isFetching ? (
                          <ClosureTableSkeleton rows={itemsPerPage} />
                        ) : currentPageData?.length > 0 ? (
                          currentPageData.map((item, index) => (
                            <tr key={item._id} className="border-b hover:bg-gray-50 transition-colors">
                              <td className="px-6 py-4 whitespace-nowrap">
                                <Link
                                  onClick={() => localStorage.setItem('iName', item?.investorName)}
                                  to={`/super_admin/running-cases/deposits/${item?._id}`}
                                  className="font-medium text-secondary hover:text-primary transition-colors"
                                >
                                  {item?.investorName || 'N/A'}
                                </Link>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-center">
                                <span className="inline-block text-sm text-black py-1 px-3 bg-blue-50 rounded-full">
                                  {item?.investorCnic || 'N/A'}
                                </span>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-center">
                                <span className="inline-block text-sm text-black py-1 px-3 bg-purple-50 rounded-full">
                                  {getPlanName(item)}
                                </span>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-center">
                                <span className="inline-block text-sm text-black py-1 px-3 bg-yellow-50 rounded-full">
                                  {item?.numberOfYears || 0} {item?.numberOfYears === 1 ? 'year' : 'years'}
                                </span>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-center">
                                <span className="inline-block text-sm text-black py-1 px-3 bg-green-50 rounded-full font-medium">
                                  Rs. {formatCurrency(item?.totalDepositedAmount || 0)}
                                </span>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-center">
                                <span className="inline-block text-sm text-black py-1 px-3 bg-indigo-50 rounded-full">
                                  {formatDate(item?.firstDepositDate) || 'N/A'}
                                </span>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-center">
                                <Link
                                  to={`/super_admin/running-cases/deposits/${item?._id}`}
                                  className="inline-block bg-secondary hover:bg-primary text-white px-4 py-2 rounded-md text-sm transition-colors shadow-sm"
                                >
                                  Deposits
                                </Link>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center py-8">
                              <div className="flex flex-col items-center justify-center">
                                <p className="text-gray-500 text-lg mb-2">No running cases found</p>
                                <p className="text-gray-400 text-sm">
                                  {searchTerm ? 'Try a different search term' : 'Push enrollments from Upcoming Closures'}
                                </p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {filteredDeposits.length > 0 && (
              <div className="flex flex-col sm:flex-row justify-between items-center py-4 px-6 border-t bg-gray-50">
                <div className="text-sm text-gray-600 mb-3 sm:mb-0">
                  Showing {Math.min((currentPage - 1) * itemsPerPage + 1, filteredDeposits.length)} to {Math.min(currentPage * itemsPerPage, filteredDeposits.length)} of {filteredDeposits.length} entries
                </div>
                <div className="flex items-center gap-4">
                  <button
                    className={`${currentPage === 1 ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'bg-secondary text-white hover:bg-primary'
                      } flex justify-center items-center w-9 h-9 rounded-md transition-colors shadow-sm`}
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    <FaAngleLeft size={18} />
                  </button>
                  <span className="text-primary font-medium text-sm">
                    Page {currentPage} of {Math.ceil(filteredDeposits.length / itemsPerPage)}
                  </span>
                  <button
                    className={`${currentPage * itemsPerPage >= filteredDeposits.length
                      ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                      : 'bg-secondary text-white hover:bg-primary'
                      } flex justify-center items-center w-9 h-9 rounded-md transition-colors shadow-sm`}
                    disabled={currentPage * itemsPerPage >= filteredDeposits.length}
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    <FaAngleRight size={18} />
                  </button>
                </div>
              </div>
            )}
          </div>
        </section>
      </Super_admin_web_protal>
    </>
  );
};

export default SuperRunningCases;